import React, { useState } from "react";
import { Modal, Input, List, Button } from "antd";

import useCreate from "hooks/useCreate";
import { useCustomComments } from "context/providers/custom_comments";

import Item from "./Item";

const ManageModal = ({ handleClose }) => {
  const { data, refetch } = useCustomComments();

  const [content, setContent] = useState("");

  const { is_saving, create } = useCreate({
    path: "/custom_comments",
    onSuccess: refetch,
  });

  const handleOk = async () => {
    try {
      await create({
        content,
      });
      setContent("");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
      style={{ top: 45 }}
      maskClosable={false}
      width={700}
      title="Zarządzaj stałymi komentarzami"
      open={true}
      cancelText="Zamknij"
      onOk={(e) => {
        e.stopPropagation();
        handleClose();
      }}
      onCancel={(e) => {
        e.stopPropagation();
        handleClose();
      }}
      cancelButtonProps={{ style: { display: "none" } }}
      okText="Zamknij"
    >
      <Input.TextArea
        style={{ marginBottom: 20 }}
        value={content}
        onChange={({ target: { value } }) => setContent(value)}
        rows={7}
        maxLength={400}
        showCount={true}
      />
      <Button
        type="primary"
        htmlType="submit"
        onClick={handleOk}
        disabled={!content || is_saving}
        loading={is_saving}
      >
        Dodaj
      </Button>
      <List
        style={{
          marginTop: 24,
          maxHeight: 300,
          overflowY: "scroll",
        }}
        bordered
        dataSource={data}
        renderItem={(el, i) => (
          <Item
            {...el}
            refetch={refetch}
            is_first={i === 0}
            is_last={i === data?.length - 1}
          />
        )}
      />
    </Modal>
  );
};

export default ManageModal;
